import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { useMemo } from 'react';
var DEFAULT_SIZE = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
export default function useOffsets(tabs, tabSizes, holderScrollWidth, inkBar) {
  return useMemo(function () {
    var map = new Map();
    var lastOffset = tabs[0] ? tabSizes.get(tabs[0].key) : DEFAULT_SIZE;
    var rightOffset = lastOffset ? lastOffset.left + lastOffset.width : 0;

    for (var i = 0; i < tabs.length; i += 1) {
      var _inkBar$clientWidth, _entity$height;

      var key = tabs[i].key;
      var data = tabSizes.get(key); // Reuse last one when not exist yet

      if (!data) {
        data = tabs[i - 1] ? tabSizes.get(tabs[i - 1].key) : DEFAULT_SIZE;
      }

      var entity = map.get(key) || _objectSpread({}, data); // Right


      entity.right = rightOffset - entity.left - entity.width; // ink-bar 实际宽度

      var inkBarWidth = (_inkBar$clientWidth = inkBar === null || inkBar === void 0 ? void 0 : inkBar.clientWidth) !== null && _inkBar$clientWidth !== void 0 ? _inkBar$clientWidth : 0; // 重新计算水平方向时 ink-bar 的位置

      entity.inkBarLeft = entity.left; // 超出的tabs，这里的width是undefined

      if (inkBarWidth && entity.left != null) {
        var _entity$width;

        entity.inkBarLeft = entity.left + (entity.width != null ? (((_entity$width = entity.width) !== null && _entity$width !== void 0 ? _entity$width : 0) - inkBarWidth) / 2 : 0);
      }

      if (entity.top == null) {
        entity.top = 0;
      } // 重新计算垂直方向时 ink-bar 的位置


      entity.top += (((_entity$height = entity.height) !== null && _entity$height !== void 0 ? _entity$height : 0) - 20) / 2;
      entity.inkBarWidth = inkBarWidth;
      entity.inkBarHeight = 20;
      entity.isFirst = i === 0;
      entity.isLast = i === tabs.length - 1; // Update entity

      map.set(key, entity);
    }

    return map;
  }, [tabs.map(function (tab) {
    return tab.key;
  }).join('_'), tabSizes, holderScrollWidth]);
}